import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ImageModule, IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { MediaLightboxModule } from '@epicuro-next/ataraxia/media-lightbox';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { dynamicElementsOrderProductThumbKey } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

@DynamicComponentRegister(dynamicElementsOrderProductThumbKey, true)
@Component({
  selector: 'epc-order-product-thumb',
  templateUrl: './order-product-thumb.component.html',
  styleUrls: ['./order-product-thumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MediaLightboxModule, ImageModule, TooltipDirective],
})
export class OrderProductThumbComponent {
  public imageMaxSizes = IMAGE_MAX_SIZES;

  @Input() public imageUrl = '';
  @Input() public title = '';
  @Input() public number = '';
  @Input() public csPath?: string[];

  @Output()
  public thumbClick = new EventEmitter<string[] | undefined>();
}

DontTreeShake(OrderProductThumbComponent);
